import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TConfirmedOrdersResponsePayload,
	TOrdersRequest,
	TOrdersStore,
	TCreateOrderReturnActionPayload,
	TCreateOrderDiscountActionPayload,
	TVatAndEASFeeResponsePayload,
	TOrderDetailsCombinedRequest,
	TOrderDetailsCombinedResponsePayload,
} from './types';
// ==========================================:
export const initialState: TOrdersStore = {
	confirmedOrders: null,
	confirmedOrdersLoader: false,
	confirmedOrdersForFilterId: null,
	confirmedOrdersForFilterIdLoader: false,
	orderDetailsCombined: null,
	orderDetailsCombinedLoader: false,
	createOrderReturnLoader: false,
	createOrderDiscountLoader: false,
	vatAndEASFee: null,
	vatAndEASFeeLoader: false,
};

// ==========================================:
const orders = createSlice({
	name: '@@orders',
	initialState,
	reducers: {
		getConfirmedOrdersRequest: (state: TOrdersStore, action: PayloadAction<TOrdersRequest>) => {
			const ordersState = state;
			ordersState.confirmedOrdersLoader = true;
		},
		getConfirmedOrdersSuccess: (
			state: TOrdersStore,
			action: PayloadAction<TConfirmedOrdersResponsePayload>,
		) => {
			const { payload } = action;
			const ordersState = state;
			ordersState.confirmedOrders = payload;
			ordersState.confirmedOrdersLoader = false;
		},
		getConfirmedOrdersForFilterIdRequest: (
			state: TOrdersStore,
			action: PayloadAction<TOrdersRequest>,
		) => {
			const ordersState = state;
			ordersState.confirmedOrdersForFilterIdLoader = true;
		},
		getConfirmedOrdersForFilterIdSuccess: (
			state: TOrdersStore,
			action: PayloadAction<TConfirmedOrdersResponsePayload>,
		) => {
			const { payload } = action;
			const ordersState = state;
			ordersState.confirmedOrdersForFilterId = payload;
			ordersState.confirmedOrdersForFilterIdLoader = false;
		},
		resetConfirmedOrdersForFilterId: (state: TOrdersStore) => {
			const ordersState = state;
			ordersState.confirmedOrdersForFilterId = null;
			ordersState.confirmedOrdersForFilterIdLoader = false;
		},
		getOrderDetailsCombinedRequest: (
			state: TOrdersStore,
			action: PayloadAction<TOrderDetailsCombinedRequest>,
		) => {
			const ordersState = state;
			ordersState.orderDetailsCombinedLoader = true;
		},
		getOrderDetailsCombinedSuccess: (
			state: TOrdersStore,
			action: PayloadAction<TOrderDetailsCombinedResponsePayload>,
		) => {
			const { payload } = action;
			const ordersState = state;
			ordersState.orderDetailsCombined = payload;
			ordersState.orderDetailsCombinedLoader = false;
		},
		createOrderReturnRequest: (
			state: TOrdersStore,
			action: PayloadAction<TCreateOrderReturnActionPayload>,
		) => {
			const ordersState = state;
			ordersState.createOrderReturnLoader = true;
		},
		createOrderReturnSuccess: (state: TOrdersStore) => {
			const ordersState = state;
			ordersState.createOrderReturnLoader = false;
		},
		createOrderDiscountRequest: (
			state: TOrdersStore,
			action: PayloadAction<TCreateOrderDiscountActionPayload>,
		) => {
			const ordersState = state;
			ordersState.createOrderDiscountLoader = true;
		},
		createOrderDiscountSuccess: (state: TOrdersStore) => {
			const ordersState = state;
			ordersState.createOrderDiscountLoader = false;
		},
		getVatAndEASFeeRequest: (state: TOrdersStore) => {
			const ordersState = state;
			ordersState.vatAndEASFeeLoader = true;
		},
		getVatAndEASFeeSuccess: (
			state: TOrdersStore,
			action: PayloadAction<TVatAndEASFeeResponsePayload>,
		) => {
			const { payload } = action;
			const ordersState = state;
			ordersState.vatAndEASFee = payload;
			ordersState.vatAndEASFeeLoader = false;
		},
		ordersInitState: () => initialState,
	},
});

export default orders.reducer;
export const {
	getConfirmedOrdersRequest,
	getConfirmedOrdersSuccess,
	getConfirmedOrdersForFilterIdRequest,
	getConfirmedOrdersForFilterIdSuccess,
	resetConfirmedOrdersForFilterId,
	getOrderDetailsCombinedRequest,
	getOrderDetailsCombinedSuccess,
	createOrderReturnRequest,
	createOrderReturnSuccess,
	createOrderDiscountRequest,
	createOrderDiscountSuccess,
	getVatAndEASFeeRequest,
	getVatAndEASFeeSuccess,
	ordersInitState,
} = orders.actions;
